// 登录页
import PageClock from "@/components/sc/PageClock"
import IconFont from "@/components/sc/IconFont"
import api from "@/net/api"
import store, { tokenSlice } from "@/store"
import { UserOutlined } from "@ant-design/icons"
import { Button, Card, Input, Layout, Modal, Space } from "antd"
import { useState, useEffect } from "react"
import "./index.less"
const md5 = require("md5")

import { useSelector } from "react-redux"

import ImgLoginBg from "@/assets/img/login-bg.png"
import ImgLogo from "@/assets/img/logo.png"
import { sysuserInfoSlice } from "@/store"

const { Header, Content } = Layout

export default function Login(props) {
	let [username, setUsername] = useState("")
	let [password, setPassword] = useState("")

	// 登录：提交账号密码
	async function submitForm() {
		localStorage.removeItem("sc_manager_front")
		// 登录接口
		try {
			let d = await api.gate_login({ username, password: md5(password) })
			store.dispatch(tokenSlice.actions.save(d))
			let r = await api.sysuser_user_info()

			// TODO
			r.orgRegionName = "潍坊学院"

			store.dispatch(sysuserInfoSlice.actions.save(r))
			props.history.replace("/")
		} catch(e) {
			console.log(e)
		}
	}

	return <div className="pages_main">
		<img className="main-bg" src={ImgLoginBg} alt="logo" />
		<Layout className="main-layout">
			<Header className="layout-header">
				<div className="header-left">
					<img className="left-img" src={ImgLogo} alt="logo" />
				</div>
				<PageClock />
			</Header>

			<Content className="pages_login">
				<div className="login-top">
					<div className="title">供采查询服务前台</div>
					<div className="sub-title">Purchase query service foreground</div>
				</div>
				<div className="form">
					<Input value={username} className="input" size="large" onChange={(e) => {
						let val = String(e.target.value).trim()
						setUsername(val)
					}}  placeholder="请输入账号..." />
					<Input.Password value={password} className="input" size="large" onPressEnter={submitForm}
						onChange={(e) => { setPassword(e.target.value) }} placeholder="请输入密码..." />
					<Button type="primary" className="button" onClick={submitForm}>登录</Button>
				</div>

				<div style={{
					background: "transparent",
					fontSize: "18px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					marginBottom: "39px",
					color: "#fff",
				}}>
					<div style={{ marginRight: "20px" }}>技术支持: 山东荣大信息科技有限公司</div>
					<div>联系电话: 400-998-9912</div>
				</div>
			</Content>
		</Layout>
	</div>
}

